/* eslint-disable camelcase */

function trackUserId(response) {
  try {
    window.ga("set", "dimension2", response.data.customer.id);
  } catch (e) {
    return response;
  }

  try {
    window.ga("set", "dimension2", response.data.data.id);
  } catch (e) {
    return response;
  }

  return response;
}

function clearUserId(response) {
  try {
    window.ga("set", "dimension2", "");
  } catch (e) {
    return response;
  }

  return response;
}

export default api => {
  function getUser() {
    return api.get("/_svc/auth-v1/partner").then(trackUserId);
  }

  function getSeller() {
    return api.get("/_svc/slapi-v1/seller").then(trackUserId);
  }

  function logout() {
    return api.post("/_svc/auth-v1/auth/signout").then(clearUserId);
  }

  function acceptTerms(seller) {
    return api.post(`/_svc/slapi-v1/seller/agreement`).then(trackUserId);
  }

  function getTnC(country) {
    let page = "terms-sellers-uae";
    switch (country) {
      case "sa":
        page = "terms-sellers-ksa";

        break;
      case "ae":
        page = "terms-sellers-uae";

        break;
      case "eg":
        page = "terms-sellers-eg";

        break;
      default:
        page = "terms-sellers-uae";
    }
    return api.get(`/_svc/catalog/api/u/${page}`);
  }

  function getWareHouses(query) {
    return api.get(`/_svc/slapi-v1/seller/warehouses${query || ""}`);
  }

  function getVatInfo() {
    return api.get("/_svc/slapi-v1/seller/vat");
  }

  function getUsersList() {
    return api.get("/_svc/slapi-v1/store/users");
  }
  function getOfferCount() {
    return api.get("/_svc/slapi-v1/offers/badge/count");
  }

  function syncInventory() {
    return api.get("/_svc/slapi-v1/inventory/sync");
  }

  function getNotification(query) {
    return api.get(`/_svc/slapi-v1/notifications${query ? "?" + query : ""}`);
  }

  function readNotification(notObj) {
    return api.post(`/_svc/slapi-v1/notifications/action`, notObj);
  }

  function getNotificationPreference() {
      return api.get(`/_svc/slapi-v1/seller/settings/warehouses`);
  }

  function postPreference(query) {
      return api.post(`/_svc/slapi-v1/seller/settings/warehouses`, query);
  }

  function getFbnSettings() {
      return api.get(`/_svc/slapi-v1/seller/settings/fbn`);
  }

  function postFbnSettings(query) {
      return api.post(`/_svc/slapi-v1/seller/settings/fbn`, query);
  }

  return {
    getUser,
    getSeller,
    logout,
    acceptTerms,
    getTnC,
    getWareHouses,
    getUsersList,
    getVatInfo,
    getOfferCount,
    syncInventory,
    getNotification,
    readNotification,
    getNotificationPreference,
    postPreference,
    getFbnSettings,
    postFbnSettings
  };
};



// WEBPACK FOOTER //
// ./src/services/UserService.js